const LogsModal = ({onClose, children}) => (
    <>
        <div className='fixed inset-0 z-[1000] bg-black/40 backdrop-blur-sm' onClick={onClose} />
        <div className='fixed inset-x-4 top-[15%] z-[1001] mx-auto max-w-[560px]'>
            <div className='relative max-h-[70vh] overflow-y-auto rounded-2xl bg-white p-4 text-color-primary shadow-xl'>
                {children}
            </div>
        </div>
    </>
);

export default LogsModal;
